// extracted by mini-css-extract-plugin
export default {"gridBox":"edit_gridBox__9MCLF"};